import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  return <p className={`text-[11px] font-extrabold uppercase tracking-[0.2em] sm:text-xs ${tone === 'dark' ? 'text-kidney-bright' : 'text-kidney-dark'}`} data-id="element-64" data-mp="2yesxqr2oygfn">
      {children}
    </p>;
}